import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../../components/notice/index'
import main from '../../components/notice/main'
import editor from '../../components/notice/editor'
import outbox from '../../components/notice/outbox'
import inbox from '../../components/notice/inbox'
import detail from '../../components/notice/detail'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: index,
  children: [
    {
      // 当 /user/:id/profile 匹配成功，
      // UserProfile 会被渲染在 User 的 <router-view> 中
      path: '/editor',
      component: editor
    },
    {
      path: '/outbox',
      component: outbox
    },
    {
      path: '/inbox/',
      component: inbox
    },
    {
      path: '/detail',
      component: detail
    }

  ]
}]

// 3. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
export default new VueRouter({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/notice/notice.js